import { LegendDefinition } from "hooks/legendHooks";

import { LegendRuleItem } from "./LegendRuleItem";

interface Props {
  definition: LegendDefinition;
}

export function LegendItem(props: Props) {
  const { definition } = props;
  return (
    <>
      {definition.rules.map((rule, i) => (
        <LegendRuleItem
          rule={rule}
          key={`rule-${definition.layerName}-${rule.name}-${i}`}
        />
      ))}
    </>
  );
}
